import React from 'react';
import { Field } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';

import { Input } from 'components';

import useStyles from './styles';

const GuestInformation = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.sectionIndent}>
      <Typography variant="h2" className={classes.inputIndent}>
        {t('Guest information')}
      </Typography>
      <div className={classes.guestInfoRow}>
        <Field
          name="firstName"
          placeholder="First name"
          className={classes.guestInfoField}
          label="First name *"
          component={Input}
        />
        <Field
          name="lastName"
          placeholder="Last name"
          className={classes.guestInfoField}
          label="Last name *"
          component={Input}
        />
      </div>
      <div className={classes.guestInfoRow}>
        <Field
          name="phone"
          placeholder="Phone"
          className={classes.guestInfoField}
          label="Phone *"
          isOnlyNumber={true}
          isPhoneNumber={true}
          maxLength={20}
          component={Input}
        />
        <Field
          name="email"
          placeholder="Email"
          className={classes.guestInfoField}
          label="Email *"
          component={Input}
        />
      </div>
    </div>
  );
};

export default GuestInformation;
